import configStore from "../../stores/ConfigStore";


import { ClientTelemetryEvent } from "./ClientTelemetryEvent";

export default class TelemetryDataService {

    /**
     * Returns a api token from the argus based on a identity in the cookie
     *
     * @static
     * @returns {Promise<Token>}
     * @memberof TokenDataService
     */
    public static reportAsync = async (data: ClientTelemetryEvent): Promise<any> => {

        const url = `${configStore.hosts.api}/telemetry/client`;
        const token = await configStore.getTokenAsync();
        await fetch(url, {
            body: JSON.stringify(data),
            credentials: "omit",
            headers: {
                "Authorization": `bearer ${token}`,
                "Content-Type": "application/json",
            },
            method: "POST",
        });
    }
}
